function setCookie(name, value, minutes) {
      window.dataLayer.forEach((elem) => {
          if (elem.event === "cookie_cat_marketing" || elem.action === "onAcceptAllServices") {
              let date = new Date();
              date.setTime(date.getTime() + (minutes * 60 * 1000));
              let c_value = escape(value) + ((minutes == null) ? "" : "; expires=" + date.toUTCString() + "; path=/");
              document.cookie = name + "=" + c_value;

              return document.cookie;
          }
      });
      localStorage.setItem(name, value);
  }
      
  function getCookie(name) {
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i].trim();
          if (cookie.startsWith(name + '=')) {
              return unescape(cookie.substring(name.length + 1));
          }
      }
      return null; // Cookie not found
  }

  function neffyDLCheck(event, firstClick) {
    let cookieAccepted = 0;
    let link = event.currentTarget.getAttribute("href");
    if (this.getCookie('_gcl_au') != '' && this.getCookie('_gcl_au') != null && this.getCookie('_gcl_au') != '_gcl_au') {
      cookieAccepted = 1;
    }

    if(cookieAccepted == 1 && firstClick == 1) {
      console.log('its first click when cookie accepted.');
      event.preventDefault();
      return false;
    }
  }
  
//   setTimeout(function() {
    // datalayers on neffy lp
    var fc = 0;
    const bodyEl = document.querySelector('body');
    const classString = bodyEl.className; // or element.getAttribute('class')
    // if (classString.includes('template-index')) {
    //     if(document.querySelector('[data-section-id="index-header-slider"].main-banner a')) {
    //         document.querySelector('[data-section-id="index-header-slider"].main-banner a').addEventListener('click', (e) => {
    //             window.dataLayer.push({
    //             'event': 'checklist_download_position_1'
    //             });
                
    //             fc = fc + 1;
    //             neffyDLCheck(e, fc);
    //         });
    //     }
    // }
    if (classString.includes('neffy-lp') || classString.includes('neffy-lp-v2')) {
        if(document.querySelector('.neffy-banner-sub-wrapper .download-checklist-btn-new')) {
        document.querySelector('.neffy-banner-sub-wrapper .download-checklist-btn-new').addEventListener('click', (e) => {
            window.dataLayer.push({
            'event': 'checklist_download_position_1'
            });
            
            fc = fc + 1;
            neffyDLCheck(e, fc);
        });
        }
        else {
        document.querySelector('.neffy-see-doc-strip .big-arrow-background').addEventListener('click', (e) => {
            window.dataLayer.push({
            'event': 'checklist_download_position_1'
            });

            fc = fc + 1;
            neffyDLCheck(e, fc);
        });
        }
        
        if(document.querySelector('.neffy-see-doc-strip .download-checklist-btn-new')) {
        if (window.innerWidth < 768) {
            document.querySelector('.neffy-see-doc-strip .download-checklist-btn-new.d-flex').addEventListener('click', (e) => {
            window.dataLayer.push({
                'event': 'checklist_download_position_2'
            });

            fc = fc + 1;
            neffyDLCheck(e, fc);
            });
        }
        else{
            document.querySelector('.neffy-see-doc-strip .download-checklist-btn-new.d-md-inline-flex').addEventListener('click', (e) => {
            window.dataLayer.push({
                'event': 'checklist_download_position_2'
            });

            fc = fc + 1;
            neffyDLCheck(e, fc);
            });
        }
        }
        else {
        document.querySelector('.neffy-see-doc-strip a.download-checklist-btn').addEventListener('click', (e) => {
            window.dataLayer.push({
            'event': 'checklist_download_position_2'
            });

            fc = fc + 1;
            neffyDLCheck(e, fc);
        });
        }

        if(document.querySelector('.neffy-text-with-image-container .layout-right .download-checklist-btn-new')) {
        if (window.innerWidth < 768) {
            document.querySelector('.neffy-text-with-image-container .layout-right .download-checklist-btn-new.d-flex').addEventListener('click', (e) => {    
            window.dataLayer.push({
                'event': 'checklist_download_position_3'
            });

            fc = fc + 1;
            neffyDLCheck(e, fc);
            });
        }
        else {
            document.querySelector('.neffy-text-with-image-container .layout-right .download-checklist-btn-new.d-md-inline-flex').addEventListener('click', (e) => {    
            window.dataLayer.push({
                'event': 'checklist_download_position_3'
            });

            fc = fc + 1;
            neffyDLCheck(e, fc);
            });
        }
        }
        else {
        document.querySelector('.neffy-text-with-image-container .layout-right .download-checklist-btn').addEventListener('click', (e) => {
            window.dataLayer.push({
            'event': 'checklist_download_position_3'
            });

            fc = fc + 1;
            neffyDLCheck(e, fc);
        });
        }

        if(document.querySelector('.neffy-text-with-image-container .layout-right .download-checklist-btn-new')) {
        if (window.innerWidth < 768) {
            document.querySelector('.neffy-text-with-image-container .layout-left .download-checklist-btn-new.d-flex').addEventListener('click', (e) => {
            window.dataLayer.push({
                'event': 'checklist_download_position_4'
            });

            fc = fc + 1;
            neffyDLCheck(e, fc);
            });
        }
        else {
            document.querySelector('.neffy-text-with-image-container .layout-left .download-checklist-btn-new.d-md-inline-flex').addEventListener('click', (e) => {
            window.dataLayer.push({
                'event': 'checklist_download_position_4'
            });

            fc = fc + 1;
            neffyDLCheck(e, fc);
            });
        }
        }
        else {
        document.querySelector('.neffy-text-with-image-container .layout-left .download-checklist-btn').addEventListener('click', (e) => {
            window.dataLayer.push({
            'event': 'checklist_download_position_4'
            });

            fc = fc + 1;
            neffyDLCheck(e, fc);
        });
        }
    }
//   }, 2000);